// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"c83c6521","179":"6961043a","212":"b67d6aac","331":"71f1c5bb","691":"72994f01","796":"2acb2762","824":"f7133e3a","977":"9a93a454"}[chunkId] + ".chunk.js";
};